import { format, isValid, parseISO } from "date-fns";

export const isValidBirthDate = (value) => {
  if (!value) return true;

  const date = parseISO(value);

  return (
    isValid(date) &&
    format(date, "yyyy-MM-dd") === value &&
    value >= "0001-01-01" &&
    value <= format(new Date(), "yyyy-MM-dd")
  );
};
